import React from "react";
import { AboutUs } from "../pages/AboutUs/AboutUs";
import { Panel } from "../pages/Panel/Panel";
import Login from "../pages/Login";
import { Main } from "../pages/Main/Main";
import { Press } from "../pages/Press";
import { Setting } from "../pages/Setting";
import { DigitalSolutions } from "../pages/DigitalSolution/DigitalSolution";
import { ExecutiveCompensation } from "../pages/ExecutiveCompensation/ExecutiveCompensation";
import { BoardOfDirectorsPay } from "../pages/BoardOfDirectorsPay/BoardOfDirectorsPay";
import { Esg } from "../pages/Esg/Esg";
import { Articles } from "../pages/Articles/Articles";

export interface IRoute {
  path: string;
  component: React.ComponentType;
  exact?: boolean;
}
export enum RouteNames {
  LOGIN = "/login",
  MAIN = "/",
  LOGOUT = "/logout",
  // SETTING =  '/setting',
  ABOUTUS = "/aboutUs",
  OURTEAM = "/ourTeam",
  ARTICLES = "/articles",
  // PRESS =  '/press',
  // PANEL =  '/panel',
  DIGITALSOLUTION = "/digitalSolution",
  EXECUTIVECOMPENSATION = "/executiveCompensation",
  BOARDOFDIRECTORYPAY = "/boardOfDirectorsPay",
  ESG = "/esg",
}

export const publicRoutes: IRoute[] = [
  { path: RouteNames.MAIN, exact: true, component: Main },
  { path: RouteNames.LOGIN, exact: true, component: Login },
  { path: RouteNames.ABOUTUS, exact: true, component: AboutUs },
  {
    path: RouteNames.DIGITALSOLUTION,
    exact: true,
    component: DigitalSolutions,
  },
  {
    path: RouteNames.EXECUTIVECOMPENSATION,
    exact: true,
    component: ExecutiveCompensation,
  },
  {
    path: RouteNames.BOARDOFDIRECTORYPAY,
    exact: true,
    component: BoardOfDirectorsPay,
  },
  { path: RouteNames.ARTICLES, exact: true, component: Articles },
  { path: RouteNames.ESG, exact: true, component: Esg },
  // { path: RouteNames.PRESS, exact: true, component: Press },
];

export const privateRoutes: IRoute[] = [
  { path: RouteNames.MAIN, exact: true, component: Main },
  { path: RouteNames.ABOUTUS, exact: true, component: AboutUs },
  // { path: RouteNames.PRESS, exact: true, component: Press },
  // { path: RouteNames.SETTING, exact: true, component: Setting },
  // { path: RouteNames.PANEL, exact: true, component: Panel },
  {
    path: RouteNames.DIGITALSOLUTION,
    exact: true,
    component: DigitalSolutions,
  },
  {
    path: RouteNames.EXECUTIVECOMPENSATION,
    exact: true,
    component: ExecutiveCompensation,
  },
  {
    path: RouteNames.BOARDOFDIRECTORYPAY,
    exact: true,
    component: BoardOfDirectorsPay,
  },
  { path: RouteNames.ESG, exact: true, component: Esg },
];
